import { gql, TypedDocumentNode } from '@apollo/client';
import {
    Mutation,
    MutationDeleteAttachmentsArgs,
    MutationSaveAttachmentsArgs,
    Query,
    QueryAttachmentsArgs
} from 'sr-types/lib/attachment/v1/graphql';
import { AttachmentFieldsFragment, ReferenceFragment } from '../../list/fragments';

export const attachmentsQuery: TypedDocumentNode<Pick<Query, 'attachments'>, QueryAttachmentsArgs> = gql`
    query Attachments($entityId: ID!, $entityType: String!, $contextTerm: String) {
        attachments(entityId: $entityId, entityType: $entityType, contextTerm: $contextTerm) {
            ...AttachmentFields
        }
    }
    ${AttachmentFieldsFragment}
`;

export const saveAttachmentsMutation: TypedDocumentNode<
    Pick<Mutation, 'saveAttachments'>,
    MutationSaveAttachmentsArgs
> = gql`
    mutation SaveAttachments($entityId: ID!, $entityType: String!, $contextTerm: String, $input: [AttachmentInput]) {
        saveAttachments(entityId: $entityId, entityType: $entityType, contextTerm: $contextTerm, input: $input) {
            id
            errors {
                field
                key
                message
            }
            reference {
                ...Reference
            }
        }
    }
    ${ReferenceFragment}
`;

export const deleteAttachmentsMutation: TypedDocumentNode<
    Pick<Mutation, 'deleteAttachments'>,
    MutationDeleteAttachmentsArgs
> = gql`
    mutation DeleteAttachments($entityId: ID!, $entityType: String!, $input: [AttachmentInput]) {
        deleteAttachments(entityId: $entityId, entityType: $entityType, input: $input) {
            id
            errors {
                field
                key
                message
            }
            reference {
                ...Reference
            }
        }
    }
    ${ReferenceFragment}
`;
